import React, { useState } from "react";
import AnalyticsTracker from "../../../GASetup/AnalyticsTracker";
import { Helmet } from "react-helmet-async";
import {
  Box,
  Typography,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { headingFonts, primaryButtonStyles } from "../../../../Styles/Styles";

export default function DatabaseBackup() {
  const [logs, setLogs] = useState([]);
  const [running, setRunning] = useState(false);

  const startBackup = () => {
    setLogs([]);
    setRunning(true);

    const eventSource = new EventSource(
      `${process.env.REACT_APP_API_SERVER_BASE_URL}/backup/database`
    );

    eventSource.onmessage = (event) => {
      setLogs((prevLogs) => [...prevLogs, event.data]);
    };

    // Listen for the "end" event sent from backend
    eventSource.addEventListener("end", (event) => {
      setLogs((prevLogs) => [...prevLogs, "✅ Backup Completed."]);
      setRunning(false);
      eventSource.close();
    });

    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
      setLogs((prevLogs) => [...prevLogs, "❌ Connection lost."]);
      setRunning(false);
      eventSource.close();
    };
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Helmet>
        <title>Database Backup - Listed.ky</title>
        <meta name="description" content="Database Backup - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h4" sx={{ ...headingFonts }}>
          Database Backup
        </Typography>
        <Button
          variant="contained"
          sx={{ ...primaryButtonStyles }}
          disabled={running}
          onClick={startBackup}
        >
          {running ? "Running..." : "Run Backup"}
        </Button>
      </Box>

      <Paper
        sx={{
          p: 2,
          height: 400,
          overflowY: "auto",
          backgroundColor: "#111",
          color: "#0f0",
          fontFamily: "monospace",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Live Logs:
        </Typography>
        <List dense>
          {logs.map((log, index) => (
            <ListItem key={index}>
              <ListItemText
                primary={log}
                primaryTypographyProps={{ style: { color: "#0f0" } }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </Box>
  );
}
